import { RouteRecordRaw } from 'vue-router'

const PosHub = () =>
  import(/* webpackChunkName: "pos-hub" */ './pages/index.vue')

const PosShifts = () =>
  import(/* webpackChunkName: "pos-shifts" */ './pages/shifts/index.vue')

const PosShiftShow = () =>
  import(/* webpackChunkName: "pos-shift-show" */ './pages/shifts/ShowPage.vue')

const PosSaleShow = () =>
  import(/* webpackChunkName: "pos-sale-show" */ './pages/sales/ShowPage.vue')

const PosReports = () =>
  import(/* webpackChunkName: "pos-reports" */ './pages/reports/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'punto-de-venta',
    name: 'pos-hub',
    component: PosHub,
    meta: {
      title: 'Punto de venta',
      auth: {
        requiredPermission: 'pos.view',
        requiredModule: 'pos',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'punto-de-venta/turnos',
    name: 'pos-shifts',
    component: PosShifts,
    meta: {
      title: 'Turnos de caja',
      auth: {
        requiredPermission: 'pos.shifts.view',
        requiredModule: 'pos',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'punto-de-venta/turnos/:ulid',
    name: 'pos-shifts-show',
    component: PosShiftShow,
    meta: {
      title: 'Turno',
      auth: {
        requiredPermission: 'pos.view',
        requiredModule: 'pos',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'punto-de-venta/reportes',
    name: 'pos-reports',
    component: PosReports,
    meta: {
      title: 'Reportes POS',
      auth: {
        requiredPermission: 'pos.reports',
        requiredModule: 'pos',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'punto-de-venta/ventas/:ulid',
    name: 'pos-sale-show',
    component: PosSaleShow,
    meta: {
      title: 'Ticket',
      auth: {
        requiredPermission: 'pos.view',
        requiredModule: 'pos',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
